import React, { ComponentType, Fragment, FunctionComponent, ReactNode } from "react";

import { BackgroundColor, EditableControlComponentProps, FormComponentProps } from "../types";

/** Vstupní props specifických komponent */
export type FormComponentPropsWrapperProps = Readonly<{
    children: (props: FormComponentProps) => ReactNode;
}> & Pick<EditableControlComponentProps, "postponedRequired" | "required" | "recommended" | "encrypted" | "enabledVisual">;

/** Obalovací komponenta převádí props specifických formulářových komponent na obecné props technikou `render props`.
 * Komponenta podporuje převod na následující specifické props:
 * - `disabled`
 * - `backgroundColor`
 * - `readOnly`
 * pozn. detailnější popis použití jednotlivých specifických props lze nalézt v {@link FormComponentProps}.
 */
export const FormComponentPropsWrapper: FunctionComponent<FormComponentPropsWrapperProps> = ({
    children,
    postponedRequired,
    required,
    recommended,
    enabledVisual,
}) => {
    let backgroundColor = undefined;
    if (recommended) {
        backgroundColor = BackgroundColor.blue;
    } else if (required) {
        backgroundColor = BackgroundColor.yellow;
    } else if (postponedRequired) {
        backgroundColor = BackgroundColor.orange;
    }
    return (
        <Fragment>
            {children({
                disabled: !enabledVisual,
                backgroundColor,
                readOnly: !enabledVisual,
            })}
        </Fragment>
    );
};

/**
 * HOC (higher-order component) převodníku props.
 * Lze ji použít například spolu s `connect`em z balíčku `react-redux`.
 * @param FormComponent Obecná formulářová komponenta (např. EditComponent).
 */
export const withFormComponentPropsWrapper = (
    FormComponent: ComponentType<FormComponentProps>,
): FunctionComponent<Omit<FormComponentPropsWrapperProps, "children">> => (props) => (
    <FormComponentPropsWrapper {...props}>
        {(convertedProps) => (
            <FormComponent {...convertedProps} />
        )}
    </FormComponentPropsWrapper>
);
